import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IOpportunityParticipant } from "../../utils/types/models";

export default createEntityReducer<IOpportunityParticipant>(Endpoint.OpportunityParticipants, Endpoint.OpportunityParticipantsList);
